import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const initialState = {
  supervisors: [],
  supervisorById: null,
  supervisorsLoading: false,
  supervisorsError: '',
};

const supervisorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case AC.GET_SUPERVISORS_REQUEST:
    case AC.GET_SUPERVISOR_DETAILS_REQUEST:
    case AC.ADD_SUPERVISOR_REQUEST:
    case AC.EDIT_SUPERVISOR_REQUEST:
    case AC.DELETE_SUPERVISOR_REQUEST:
      return updateObject(state, {supervisorsLoading: true, supervisorsError: ''});
    case AC.GET_SUPERVISORS_SUCCEED:
      return updateObject(state, {
        supervisors: action.payload,
        supervisorsLoading: false,
      });
    case AC.GET_SUPERVISOR_DETAILS_SUCCEED:
      return updateObject(state, {
        supervisorById: action.payload,
        supervisorsLoading: false,
      });
    case AC.GET_SUPERVISORS_FAILED:
    case AC.GET_SUPERVISOR_DETAILS_FAILED:
    case AC.ADD_SUPERVISOR_FAILED:
    case AC.EDIT_SUPERVISOR_FAILED:
    case AC.DELETE_SUPERVISOR_FAILED:
      return updateObject(state, {
        supervisorsError: action.payload,
        supervisorsLoading: false,
      });
    default:
      return state;
  }
};

export default supervisorsReducer;
